import React from 'react'

export const NoMatch = () => (
    <div>
        <h2>No match
        </h2>
    </div>
)